"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualManagerComponents = void 0;
const dynamicLoadManagerComponents_1 = require("../../../dynamicLoad/dynamicLoadManagerComponents");
class DynamicLoadManualManagerComponents extends dynamicLoadManagerComponents_1.DynamicLoadManagerBaseComponents {
}
exports.DynamicLoadManualManagerComponents = DynamicLoadManualManagerComponents;
//# sourceMappingURL=managerComponents.js.map